// Structured logging has no dependency on authentication or identity services.
export * from './lib/structured-logger.service';
export * from './lib/structured-log-policy';
export * from './lib/api-diagnostics';
export * from './lib/fa-action-tracker';
export { inheritRequestCorrelation } from './lib/request-correlation';
export * from './lib/telemetry-identifiers';
